<template>
  <div class="Indice">
    <div class="Indice_mask"></div>
    <Shape ref="shape" />

    <div class="Indice_wrapper" v-if="indice">
      <div class="Close" v-if="slug == 'longuevue'" @click="close"><img class="Shape_optim" src="/assets/images/shape-small.svg" /><i class="fad fa-times-circle"></i></div>

      <img class="Indice_thumb" :src="'/assets/images/' + indice.picto" />
      <div class="Indice_content">
        <transition name="title" appear>
          <h2 v-html="indice.title" v-if="indice.title"></h2>
        </transition>
        <transition name="content" appear>
          <p v-if="indice.content" v-html="indice.content"></p>
        </transition>

        <transition name="cta" appear>
          <button class="Cta" v-if="slug == 'longuevue'" @click="openInteraction('zoom')">Utiliser</button>
          <button class="Cta" v-else-if="slug == 'boussole'" @click="close">Fermer</button>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import Shape from '@/components/partial/Shape'
  export default {
    props: [ 'slug' ],
    components: { Shape },
    data() {
      return {
        
      }
    },
    computed: {
      indice()
      {
        if(this.slug == 'longuevue')
          return { title: "Longue-vue", content: "Cette longue-vue peut être utile pour repérer le troisième chiffre manquant du code.", picto: "longuevue.svg" }
        if(this.slug == 'boussole')
          return { title: "Note", content: "Il semblerait que le deuxième chiffre manquant du code se trouve en direction de la basilique Notre-Dame de la Garde... Une boussole pourrait être utile.", picto: "carte.svg" }
      }
    },
    methods: {
      openInteraction(slug)
      {
        this.close()
        this.$emit('openInteraction', slug)
      },
      close()
      {
        this.close = new Howl({
          src: ['/assets/sounds/close.mp3']
        });
        this.close.play()
        
        this.$el.querySelector('.Shape').classList.remove('Shape_indice')
        this.$emit('closeIndice')
      }
    },
    created () {
    },
    mounted () {
      setTimeout( () => {
        this.$el.querySelector('.Shape').classList.add('Shape_indice')
      }, 10)

      this.open = new Howl({
        src: ['/assets/sounds/open.mp3']
      });
      this.open.play()

      if(this.slug == 'longuevue')
        this.$ga.event('indice_longuevue', 'open' );

      if(this.slug == 'boussole')
        this.$ga.event('indice_boussole', 'open' );
    }
  }
</script>

<style lang="stylus">
.Indice

  position fixed
  top 0px
  height 100%
  width 100%
  left 0px
  display flex
  flex-direction column
  align-items center
  // overflow-y auto
  // overflow-x visible
  // -webkit-overflow-scrolling touch
  pointer-events auto

  .Close

    right -5%
    top 0%

  &_wrapper

    position relative
    text-align center
    margin auto auto
    max-width 480px
    z-index 1
    box-sizing border-box

    @media $small

      padding 60px 30px
      max-width none

  &_mask

    position fixed
    top 0px
    left 0px
    width 100%
    height 100%
    pointer-events auto
    z-index 1

  .Cta

    margin-bottom 0px

  p

    margin-bottom 0px
    margin-top 10px
    

.safari

  .Indice
  
    @media $small

      svg

        display none!important

      .Shape

        height 100%
        width 100%

      .Shape_optim

        display block
        transform scale(1.3)


</style>